/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_HelpInputs */



/**
* | output |
* | --- |
* | "Select the template format for your CCSL export" |
*
* @param {Ccsl_Export_Template_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_help = /** @type {((inputs?: Ccsl_Export_Template_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez le format de modele pour votre exportation CCSL")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das Vorlagenformat für Ihren CCSL-Export aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il formato del modello per l'esportazione CCSL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите формат шаблона для экспорта в CCSL.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el formato de plantilla para su exportación CCSL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择 CCSL 导出模板格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCSLエクスポートのテンプレート形式を選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने CCSL निर्यात के लिए टेम्पलेट प्रारूप चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o formato do modelo para sua exportação CCSL.")
	return /** @type {LocalizedString} */ ("Select the template format for your CCSL export")
});